// Shared helpers for the AI chat components.

// Detect language of a piece of text (Hebrew vs. English default).
export const detectLanguage = (text) => {
  const hebrewRegex = /[֐-׿]/;
  if (hebrewRegex.test(text || "")) {
    return "hebrew";
  }
  return "english";
};

// Stable unique id for chat messages so React keys never fall back to
// the array index.
let messageIdCounter = 0;
export const makeMessageId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  messageIdCounter += 1;
  return `msg-${Date.now()}-${messageIdCounter}`;
};

// A message counts as having a visualization only when the explicit `html`
// field is present, or when the text contains a full sanitizable HTML block
// (e.g. <div>...</div>, <table>...</table>, <svg>...</svg>, <style>...</style>).
// Benign prose containing "<" or ">" must NOT be routed to the HTML renderer.
const HTML_BLOCK_REGEX = /<(div|table|svg|style|html)(\s[^>]*)?>[\s\S]*<\/\1\s*>/i;

export const hasHTMLContent = (message) => {
  if (message.html && message.html.trim()) {
    return true;
  }
  return HTML_BLOCK_REGEX.test(message.text || "");
};

// Extract HTML content from a message.
export const getHTMLContent = (message) => {
  if (message.html && message.html.trim()) {
    return message.html;
  }
  const match = (message.text || "").match(HTML_BLOCK_REGEX);
  return match ? match[0] : null;
};

// Clean text for display when HTML is present.
export const getDisplayText = (message) => {
  // If there's a separate HTML field, just show the text content
  if (message.html && message.html.trim()) {
    return message.text;
  }
  if (HTML_BLOCK_REGEX.test(message.text || "")) {
    return (message.text || "").replace(HTML_BLOCK_REGEX, "[HTML content below]");
  }
  return message.text;
};
